import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import FeatureCallout from '@groovehq/internal-design-system/lib/components/FeatureCallout/FeatureCallout'
import { styles as featureCalloutStyles } from '@groovehq/internal-design-system/lib/components/FeatureCallout/FeatureCallout.styles'
import {
  button,
  heading,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { HIDE_NOTE_EDIT_CALLOUT } from 'ducks/flags/flagNames'
import { doSetFlag } from 'ducks/flags'
import useFrillNotification from 'util/hooks/useFrillNotification'

const NoteEditCallout = ({ children }) => {
  const dispatch = useDispatch()
  const { onNotify, loaded } = useFrillNotification()
  const [show, setShow] = useState(true)
  const handleClose = useCallback(
    () => {
      dispatch(doSetFlag(HIDE_NOTE_EDIT_CALLOUT))
      setShow(false)
    },
    [dispatch]
  )
  const handleLearnMore = useCallback(
    () => {
      onNotify('editing-and-deleting-notes-1')
      handleClose()
    },
    [onNotify, handleClose]
  )
  const overlay = (
    <div>
      <h5
        className="grui my-4"
        css={[heading.styles.h5, text.styles.textWhite]}
      >
        New Feature
      </h5>
      You can now edit/delete notes!
      <div className="grui mt-10" css={featureCalloutStyles.footer}>
        <button
          css={button.styles.preflight}
          type="button"
          className="grui"
          onClick={handleLearnMore}
        >
          Learn more
        </button>
        <button
          css={button.styles.preflight}
          type="button"
          onClick={handleClose}
          className="grui"
        >
          Dismiss
        </button>
      </div>
    </div>
  )

  return (
    <FeatureCallout
      overlay={overlay}
      open={show && loaded}
      position="top"
      strategy="fixed"
      portal="#drawer-root"
      className="grui whitespace-normal"
    >
      {children}
    </FeatureCallout>
  )
}

export default NoteEditCallout
